import React from "react";
import ReactApexChart from "react-apexcharts";
import SaveBtn from "../../../common/SaveBtn";
import colors from "../../../../helpers/colors";
import useCompareOrientationAlgos from "./useCompareOrientationAlgos";

const CompareOrientationAlgos = ({
  url,
  year,
  displayTotal = true,
  otherPostParams = {},
}) => {
  const { isLoading, chartState, getDatas, hasDatas, totalEspoar, totalFT, totalDifferences } = useCompareOrientationAlgos(
    url,
    year,
    otherPostParams
  );

  return (
    <div className="row">
      <div className="col-12 mb-2 d-flex align-items-center justify-content-end">
        <SaveBtn
          type={hasDatas ? "btn-default d-center" : "btn-primary d-center"}
          color={hasDatas ? colors.primary : colors.default}
          margin="m-0 get-stat-btn"
          save={getDatas}
          isSaving={isLoading}
          text={
            hasDatas ? (
              <>
                <i className="fa fa-sync mr-2" />
                Actualiser les données
              </>
            ) : (
              <>
                <i className="fa fa-cloud-download-alt mr-2" />
                Charger les données
              </>
            )
          }
        />
      </div>
      {!isLoading && hasDatas ? (
        <>
        {displayTotal && (
            <div className="d-flex justify-content-center w-100 align-items-center mt-4">
              <div className="alert alert-warning bg-transparent border-0 mb-0">
                Total d'orientations différentes : <strong>{totalDifferences}</strong>
              </div>
              <div className="alert alert-info bg-transparent border-0 mb-0">
                Total ESPOAR : <strong>{totalEspoar}</strong> | Total FT : <strong>{totalFT}</strong>
              </div>
            </div>
          )}
          <div className="col-12 mt-4">
            <h5 className="text-center mb-3">
              Différences de répartition entre les algorithmes (
              <span style={{color: colors.info}}>ESPOAR</span> vs <span style={{color: colors.progress}}>FT</span>)
            </h5>
            <ReactApexChart
              options={chartState.compare.options}
              series={chartState.compare.series}
              type="bar"
              height={350}
            />
          </div>
          <div className="col-12 mb-4">
          
          </div>
          <div className="col-12 col-md-6">
            <ReactApexChart
              options={chartState.espoarPie.options}
              series={chartState.espoarPie.series}
              type="pie"
              height={350}
            />
          </div>
          <div className="col-12 col-md-6">
            <ReactApexChart
              options={chartState.ftPie.options}
              series={chartState.ftPie.series}
              type="pie"
              height={350}
            />
          </div>
       
        </>
      ) : null}
    </div>
  );
};

export default CompareOrientationAlgos;
